export default __webpack_public_path__ + "static/media/HTML5.cf51b387.svg";